<template>
  <div class="changeInput">
    <el-form :model="mesForm" :rules="changeRules" ref="ruleForm" class="demo-ruleForm" :status-icon="true" :show-message="false">
      <el-form-item>
        <div class="three">
          <div class="left">
            <el-form-item prop="length">
              <el-input v-model="mesForm.length" placeholder="Length"></el-input>
            </el-form-item>
          </div>
          <div class="middle">
            <el-form-item  prop="width">
              <el-input v-model="mesForm.width" placeholder="Width"></el-input>
            </el-form-item>
          </div>
          <div class="rights">
            <el-form-item prop="height">
              <el-input v-model="mesForm.height" placeholder="Height"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="two">
          <el-form-item prop="weight">
            <el-input v-model="mesForm.weight" placeholder="Weight"></el-input>
          </el-form-item>
        </div>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>

export default {
  name: "mesInput",
  data(){
    return{
      mesForm:{
        length: '',
        width: "",
        height: '',
        weight: "",
      },
      changeRules:{
        length: [
          { required: true, message: '',trigger: ['blur', 'change'] }
        ],
        width: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        height: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        weight: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
      },
    }
  },
  mounted() {
  },
  methods:{
    validateForm() {
      let flag = false
      this.$refs['ruleForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear(){
      this.$refs.ruleForm.resetFields()
    },
  }
}
</script>

<style scoped lang="less">
.changeInput{
  width: 100%;

  /deep/ .el-form{
    //display: flex;
    width: 100%;
  }
  .two{
    /deep/ .el-input__inner{
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-top: none;
    }
  }
  .three{
    display: flex;
    margin-top: -2px;
    .left{
      //flex:5;
      /deep/ .el-input__inner{
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        border-top-left-radius:16px;
      }
      width: 15vw;
    }
    .middle{
      //flex:1;
      /deep/ .el-input__inner{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
        border-left: none;
      }
    }
    .rights{
      //flex:5;
      /deep/ .el-input__inner{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-top-right-radius: 16px;
      }
      width: 15vw;
    }
    /deep/ .el-input__inner{
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
}
</style>
